var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "vertical-align": "middle",
      "line-height": "32px",
      "font-size": "32px",
      "aspect-ratio": "2"
    }
  }, [_vm._v(_vm._s(_vm.flag))]);

}
var staticRenderFns = []

export { render, staticRenderFns }